import React from "react";
import { FieldError, UseFormRegister } from "react-hook-form";

type TextareaFieldProps = {
  name: string;
  label: string;
  placeholder: string;
  className?: string;
  rows?: number;
  register: UseFormRegister<any>;
  validation?: Record<string, any>;
  error?: FieldError;
};

const TextArea = ({
  name,
  label,
  placeholder,
  className = "",
  rows = 4,
  register,
  validation,
  error,
}: TextareaFieldProps) => (
  <div className={`w-full space-y-1 ${className}`}>
    <label htmlFor={name} className="text-[#1E293B]  text-sm w-full">
      {label}
    </label>
    <textarea
      id={name}
      placeholder={placeholder}
      rows={rows}
      {...register(name, validation)}
      className={`px-4 py-2 text-sm w-full rounded-2xl outline-none bg-white border ${
        error ? "border-red-500" : "border-[#D8D8D8]"
      } resize-none`}
    />
    {error && (
      <p className="text-red-500 text-xs   block pl-3 ">
        {error?.message || ""}
      </p>
    )}
  </div>
);

export default TextArea;
